import React, {useEffect} from 'react';
import Layout from '../Shared/Layout';
import {Container, Grid, Paper} from "@material-ui/core";
import styled from "styled-components";
import Add from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import ReorderIcon from '@material-ui/icons/Reorder';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import Language from "@material-ui/icons/Language";
import {InertiaLink} from "@inertiajs/inertia-react";
import BackButton from "../Shared/BackButton";
import { Trans } from "../utils/i18n";

const Card = styled(InertiaLink)`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  text-align: center;
  padding: 30px;
  font-size: 20px;
  display: block;
  text-decoration: none;
  color: ${props => props.theme.text};
`;

const Wrapper = styled.div`
`;

const TableauPlaceholder = styled.div`
    width: 100%;
    height: 80vh;
    margin-top: 15px;
`;

const Object = styled.object`
    width: 100%;
    height: 80vh;
`;

const TableauWrapper = React.memo(function Lol({dashboardName}) {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://sca.b2x.com/javascripts/api/viz_v1.js";

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []);

    return (
        <>
            <TableauPlaceholder>
                <Object className='tableauViz' style={{display: 'none',}}>
                    <param name='host_url' value='https://sca.b2x.com/'/>
                    <param name='embed_code_version' value='3'/>
                    <param name='site_root' value='/t/demo'/>
                    <param name='name' value={dashboardName}/>
                    <param name='tabs' value='no'/>
                    <param name='toolbar' value='yes'/>
                    <param name='showAppBanner' value='false'/>
                </Object>
            </TableauPlaceholder>
        </>
    )
});

export default function Analytics({ dashboardName }) {
    return (
        <Wrapper>
            <Container maxWidth="lg">
                <BackButton label={<Trans i18nKey="analytics.analyticsOverview">Analytics Overview</Trans>} href={route('admin.analytics-overview')} />
            </Container>
            <TableauWrapper dashboardName={dashboardName}/>
        </Wrapper>
    )
}

Analytics.layout = page => <Layout children={page} />;
